// extracted by mini-css-extract-plugin
export default {"container":"axis_container__2GgXy"};